const BaseEvalObject = function(){
    return {
        candidate_first_name: "",
        candidate_last_name: "",
        candidate_username: "",
        candidate_email: "",
        candidate_language: "fr",
        candidate_genre: null,
        completed: false,
        completed_date: null,
        survey_time: null,
        sight_group: null,
        use_custom_email: false,
        email_subject: "",
        email_content: "",
        docs_ids: []
    }
}
export default BaseEvalObject

